"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M12 22a9.747 9.747 0 0 1-3.904-.787 10.09 10.09 0 0 1-3.173-2.136 10.09 10.09 0 0 1-2.136-3.173A9.749 9.749 0 0 1 2 12c0-1.387.262-2.688.787-3.904a10.092 10.092 0 0 1 2.136-3.173c.9-.9 1.957-1.611 3.173-2.136A9.748 9.748 0 0 1 12 2c1.387 0 2.688.262 3.904.787a10.09 10.09 0 0 1 3.173 2.136c.9.9 1.611 1.957 2.136 3.173A9.747 9.747 0 0 1 22 12a9.748 9.748 0 0 1-.787 3.904 10.09 10.09 0 0 1-2.136 3.173c-.9.9-1.957 1.611-3.173 2.136A9.748 9.748 0 0 1 12 22Zm0-2.23c2.173 0 4.012-.751 5.515-2.255C19.02 16.012 19.77 14.173 19.77 12c0-2.173-.751-4.012-2.255-5.515C16.012 4.98 14.173 4.23 12 4.23c-2.173 0-4.012.751-5.515 2.255C4.98 7.988 4.23 9.827 4.23 12c0 2.173.751 4.012 2.255 5.515C7.988 19.02 9.827 19.77 12 19.77Z"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M13.013 17.038v-5.26c0-1.118-.098-1.341-.768-1.341h-1.272v6.601h2.04Zm-1.006-7.91c.615 0 1.104-.475 1.104-1.076 0-.601-.489-1.09-1.104-1.09-.615 0-1.118.489-1.118 1.09 0 .6.503 1.076 1.118 1.076Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};